"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableCapabilitiesByEntitySet = exports.findRecursiveHierarchyKey = void 0;
var metadata_1 = require("./metadata");
Object.defineProperty(exports, "findRecursiveHierarchyKey", { enumerable: true, get: function () { return metadata_1.findRecursiveHierarchyKey; } });
Object.defineProperty(exports, "getTableCapabilitiesByEntitySet", { enumerable: true, get: function () { return metadata_1.getTableCapabilitiesByEntitySet; } });
//# sourceMappingURL=index.js.map